/**
@ngdoc directive
@name ajaxHelper

@description
    (in general - the directive way is much safer than exposing the whole service, also with helper we would end up with much tangled function call...)<br/>
    GET url or POST the whole form (for GET just remove post-data attribute). test test<br/>
    <br/>
    Available methods:<br/>
    - ajaxRequest()  - please bind ajaxRequest to whatever you need (ie. ng-click="ajaxRequest();")<br/>
    - ajaxResponse() - if you need ajax response you can use ajaxResponse() function inside your on-success and bind your model to it (the response parameter have
                           been removed in favour of this function)<br/>
    - ajaxError()    - ajax response when request failed and returns with 4xx or 5xx status, you can use inside on-error
    - abortRequest() - aborting pending request<br/>

@param {url} url ajax request dynamic url (you can use Angular variables with it - please mind you need additional single quotes ie. url="'yourUrl'+formModel.value").
@param {url=} href ajax request url (non-dynamic, also additional single quotes aren't needed), requires url attribute to be set to url="'_attrs.href_'"
@param {Object=} post-data post data to send (ie. post-data="formModel"). For GET request please don't place this parameter (cannot be just empty).
@param {expression=} on-request angular expression executed prior to ajaxRequest
@param {expression=} on-success angular expression executed on success request
@param {expression=} on-error angular expression executed on failed request
@param {boolean=} loading loading indicator

@usage
    <a href="javascript:void(0);" title="Resume"
        ajax-helper
        post-data="formModel"
        url="'/distribution/resumeDistribution/28585?type=listScreen&amp;status=Paused&amp;submissionsRemaining=&amp;submissionsMade=2&amp;supplierName=Aston+Carter&amp;itemId=10926&amp;inst=28585-4-Distribution-391%7Cfalse--false'"
        on-success="
            listingModel.suppliers.refresh = listingModel.suppliers.refresh+1;
            xmsNotifications.addObj({id: 'actionPostSuccessMsg', type: 'success', bodyHtml: 'Command executed successfully!'});
            formModel.myVariable = ajaxResponse().property"
        on-error="xmsNotifications.addObj({id: 'actionPostSuccessMsg', type: 'danger', bodyHtml: 'Error!' });"
        ng-click="ajaxRequest();"
        loading="pageModel.loading">Resume</a>

*/

(function() {
    'use strict';

    var ajaxHelper = function($timeout, ajaxCall) {
        return {
            restrict: "A",
            scope: true,
            bindToController: {
                url: '&',
                postData: "&",
                onRequest: '@',
                onSuccess: '@',
                onError: '@',
                loading: "=?"
            },
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

                var _this = this;
                _this.loading = false;

                var url;
                this.$onInit = function(){
                    if( _this.url()=='_attrs.href_' ){ // use href (for Grails)
                        url = $attrs.href;
                    } else {
                        url = _this.url();
                        // dynamic url
                        $scope.$watch(
                            function(){
                                return _this.url();
                            },
                            function(newVal, oldVal){
                                if(newVal!=oldVal){
                                    url = _this.url();
                                }
                            }
                        );
                    }
                }

                $scope.ajaxRequest = function(){

                    if(angular.isDefined( _this.onRequest )){
                        $scope.$eval( _this.onRequest );
                    }

                    $timeout(function(){ // timeout for dynamic url parameters
                        _this.loading = true; // needs to be in the timeout, otherwise it's cancelled by abort!!!
                        _this.request = ajaxCall.getData( url, _this.postData() );
                        _this.request.then(
                            function(response){
                                _this.loading = false;
                                _this.response = response.data;
                                _this.error = "";
                                if(angular.isDefined( _this.onSuccess )){
                                    $scope.$eval( _this.onSuccess );
                                }
                            },
                            function(response){
                                // _this.response = response.data; // unsure about this yet - guys do you want the response to be binded on error?
                                _this.loading = false;
                                _this.response = ""; // for now I'm clearing the response on error
                                _this.error = response.data;
                                if(angular.isDefined( _this.onError )){
                                    $scope.$eval( _this.onError );
                                }
                            }
                        );
                    });
                }

                $scope.ajaxResponse = function(){
                    return _this.response;
                }

                $scope.ajaxError = function(){
                    return _this.error;
                }

                $scope.abortRequest = function(){
                    console.log(_this.request);
                    if( angular.isDefined(_this.request) && _this.request.abort!==angular.noop ){
                        console.info('ajaxHelper: Early new request - aborting previous request.');
                        _this.request.abort(); // cancel previous request
                    }
                }

                // XMS-9230 possible solution / fix for Mark Stevenson
                /*$scope.assignResponse = function(model) {
                    angular.forEach(_this.response, function(val, key){
                        model[key] = val;
                    });
                    return model;
                }*/

                // returns date object from string - you need to convert all json date strings into object if you want to initialize date pickers
                $scope.convertJsonDateString = function(dateString){
                    // XMS-4331 If dataString is null it is set to 01 Jan 1970 instead of blank
                    if(dateString != null) {
                        return new Date(dateString);
                    }
                }
            }]
        };
    }
    ajaxHelper.$inject = ['$timeout','ajaxCall'];
    angular.module('app').directive('ajaxHelper', ajaxHelper);

}());